import React from 'react';
import DataGrid from './common/dataGrid';
import ReactModal from 'react-modal';
import { Form, FormGroup, FormRow, Col, ControlLabel, Button, Glyphicon, FormControl, Radio, FieldGroup } from 'react-bootstrap';
import { Load } from './common/basic';
import axios from 'axios';
import DropDown from './common/dropDownOne';
import enums from '../config/enums';
import { CheckBox } from './common/forms';
import Datepicker from './common/datepicker';
import CSVExport from './common/CSVExport';
import dateHelper from '../helpers/date.js';

var path = require("path");

module.exports = class Devices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTreatmentHandle: true,
            showMeasurementHandle: true
        }

        this.InFormOnUpdateOpenModal = this.InFormOnUpdateOpenModal.bind(this);
        this.informOnUpdate = this.informOnUpdate.bind(this);
        this.handleFormat = this.handleFormat.bind(this);
        this.FWFormat = this.FWFormat.bind(this);
        this.StartFormat = this.StartFormat.bind(this);
        this.EndFormat = this.EndFormat.bind(this);
        this.FWUpdateFormat = this.FWUpdateFormat.bind(this);
        this.NeedUpdateFormat = this.NeedUpdateFormat.bind(this);
        this.filter = this.filter.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.filterGridByDate = this.filterGridByDate.bind(this);
        this.removeFilters = this.removeFilters.bind(this);
        this.filterGridByFWVersion = this.filterGridByFWVersion.bind(this);
    }

    handleFormat(cell, row, enumObject, index) {
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    Treatment<br /><br />
                    Measurement
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div>
                    Treatment
                </div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>
                    Measurement
                </div>
            )
        }
    }

    FWFormat(cell, row, enumObject, index) {
        var treatmentVersion = row.TreatmentFWVersion;
        var measurementVersion = row.MeasurementFWVersion;
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    {treatmentVersion}<br /><br />
                    {measurementVersion}
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div> {treatmentVersion}</div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>{measurementVersion}</div>
            )
        }
    }

    StartFormat(cell, row, enumObject, index) {
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.TreatmentStart}<br /><br />
                    {row.MeasurementStart}
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div>
                    {row.TreatmentStart}
                </div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.MeasurementStart}
                </div>
            )
        }
    }

    EndFormat(cell, row, enumObject, index) {
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.TreatmentEnd}<br /><br />
                    {row.MeasurementEnd}
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div>
                    {row.TreatmentEnd}
                </div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.MeasurementEnd}
                </div>
            )
        }
    }

    FWUpdateFormat(cell, row, enumObject, index) {
        if (this.state.showTreatemntHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.TreatmentFWUpdate}<br /><br />
                    {row.MeasurementFWUpdate}
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div>
                    {row.TreatmentFWUpdate}
                </div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>
                    {row.MeasurementFWUpdate}
                </div>
            )
        }
    }

    NeedUpdateFormat(cell, row, enumObject, index) {
        var treatmentUpdate = (row.IsTreatmentUpdateNeeded ? <b>Yes</b> : 'No');
        var measurementUpdate = (row.IsMeasurementUpdateNeeded ? <b>Yes</b> : 'No');
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            return (
                <div>
                    {treatmentUpdate}<br /><br />
                    {measurementUpdate}
                </div>
            )
        }
        else if (this.state.showTreatmentHandle) {
            return (
                <div> {treatmentUpdate}</div>
            )
        }
        else if (this.state.showMeasurementHandle) {
            return (
                <div>{measurementUpdate}</div>
            )
        }
    }

    InFormOnUpdateOpenModal() {


        this._chooseVersion.handleOpenModal();
    }

    informOnUpdate(treatmentHandle, versionID) {
        var selectedIDs = this.refs.grid.getSelectedItemIDs();

        if (treatmentHandle === 1 || treatmentHandle === "1") {//Treatment
            selectedIDs = selectedIDs.map(x => x.TreatmentUnitID).join();
        } else if (treatmentHandle === 2 || treatmentHandle === "2") {//Analyzer
            selectedIDs = selectedIDs.map(x => x.AnalyzerUnitID).join();
        }

        axios
            .post("/data/saveFirmareUpdateNeeded/", { selected: selectedIDs, handle: treatmentHandle, versionID: versionID })
            .then(function (data) {
                this._chooseVersion.handleCloseModal();
                this.refs.grid.onSelectAll(false);

                console.log(data.data);
                // this._loading.Hide();
            }.bind(this));
    }

    filter(checkboxID, isChecked) {
        if (checkboxID == "treatmentCheckbox") {
            this.setState({
                showTreatmentHandle: isChecked
            });
        }
        else {
            this.setState({
                showMeasurementHandle: isChecked
            });
        }
    }

    onFilterChange(filterObj) {
        //console.log(filterObj);
    }

    filterGridByDate(treatmentField, measurementField, date) {
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            this.refs.grid.filterDataByDate(treatmentField, date);
            this.refs.grid.filterDataByDate(measurementField, date);
        }
        else if (this.state.showTreatmentHandle) {
            this.refs.grid.filterDataByDate(treatmentField, date);
        }
        else {
            this.refs.grid.filterDataByDate(measurementField, date);
        }
    }

    filterGridByFWVersion(treatmentField, measurementField, date) {
        if (this.state.showTreatmentHandle && this.state.showMeasurementHandle) {
            this.refs.grid.filterDataByFWVersion(treatmentField, date);
            this.refs.grid.filterDataByFWVersion(measurementField, date);
        }
        else if (this.state.showTreatmentHandle) {
            this.refs.grid.filterDataByFWVersion(treatmentField, date);
        }
        else {
            this.refs.grid.filterDataByFWVersion(measurementField, date);
        }
    }

    removeFilters() {
        this.refs.treatmentCheckbox.setState({ isChecked: true});
        this.refs.measurementCheckbox.setState({ isChecked: true});
        this.setState({
            showTreatmentHandle: true,
            showMeasurementHandle: true
        });
        this.refs.serialNumberColumn.cleanFiltered();
        this.refs.currentFWColumn.cleanFiltered();
        this.refs.grid.removeFilters();
    }

    exprotClicked() {
        var dbKeys = ['UserFullName', 'SerialNumber', 'MeasurementFWVersion', 'TreatmentFWVersion', 'MeasurementHandleMAC', 'TreatmentHandleMAC','TreatmentStart','TreatmentEnd','MeasurementStart','MeasurementEnd', 'IsMeasurementUpdateNeeded', 'IsTreatmentUpdateNeeded'];
        var csvKeys = ['User Name', 'Serial Number', 'Measurement FW Version', 'Treatment FW Version', 'Measurement Handle MAC', 'Treatment Handle MAC', 'Treatment start use','Treatment end use','Measurement start use','Measurement end use', 'Is Measurement Update Needed', 'Is Treatment Update Needed'];
        var fileName = 'Devices_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv';
        this.refs.grid.expoertCSV(dbKeys, csvKeys, fileName);
    }

    render() {
        return (
            <div className="container">
                <div>
                    <div className='row' style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <div className='col-xs-4'>
                            <h3>Device info</h3>
                        </div>
                        <div className='float-right'>
                            <button className="greenBtnInline" style={{ width: '130px' }} onClick={this.InFormOnUpdateOpenModal}>INFORM USERS ON FW UPDATES</button>
                            {/* <button className="purpleTransparentBtnInline" style={{ width: '130px' }}>INFORM USERS ON RECALL</button>
                            <button className="purpleTransparentBtnInline" style={{ width: '130px', marginRight: '15px' }}>INFORM USERS ON SERVICE REQUIRED</button> */}
                        </div>
                        <ChooseVersion ref={(chooseVersion) => { this._chooseVersion = chooseVersion; }} informOnUpdate={this.informOnUpdate} />
                        <AddVersion />
                    </div>
                </div>
                <div className="chooseHandlesDiv">
                    <CheckBox ref='treatmentCheckbox' id='treatmentCheckbox' type='checkbox' className='filter whiteCheckBox' onChange={this.filter} isChecked={true}>Treatment</CheckBox>
                    <CheckBox ref='measurementCheckbox' id='measurementCheckbox' type='checkbox' className='filter whiteCheckBox' onChange={this.filter} isChecked={true}>Measurement</CheckBox>
                </div>
                <button onClick={this.removeFilters}>Clear filters</button>
                {/* <CSVExport 
                                ajaxUrl='/data/getDeviceInfo' 
                                dbKeys={['UserFullName', 'SerialNumber', 'MeasurementFWVersion', 'TreatmentFWVersion', 'MeasurementHandleMAC', 'TreatmentHandleMAC','TreatmentStart','TreatmentEnd','MeasurementStart','MeasurementEnd', 'IsMeasurementUpdateNeeded', 'IsTreatmentUpdateNeeded']} 
                                csvKeys={['User Name', 'Serial Number', 'Measurement FW Version', 'Treatment FW Version', 'Measurement Handle MAC', 'Treatment Handle MAC', 'Treatment start use','Treatment end use','Measurement start use','Measurement end use', 'Is Measurement Update Needed', 'Is Treatment Update Needed']}
                                fileName={'Devices_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/> */}
                <Button bsStyle="link" bsSize="large" onClick={() => this.exprotClicked()}>
                    <Glyphicon glyph="glyphicon glyphicon-floppy-save" />
                </Button>
                <DataGrid ref="grid"
                    ajaxUrl='/data/getDeviceInfo'
                    ID='DeviceGrid'
                    pagination={true} 
                    onFilterChange={this.onFilterChange}
                    selectRow={true}
                    selectColumnName="TreatmentUnitID">
                    <TableHeaderColumn isKey hidden dataField='ID' />
                    <TableHeaderColumn hidden dataField='TreatmentUnitID' />
                    <TableHeaderColumn ref="serialNumberColumn" dataField='SerialNumber' dataSort filter={{ type: 'TextFilter' }}>Serial Number</TableHeaderColumn>
                    <TableHeaderColumn dataField='UserFullName' dataSort>Patient name</TableHeaderColumn>
                    <TableHeaderColumn dataField='' dataFormat={this.handleFormat}>Handle</TableHeaderColumn>
                    <TableHeaderColumn ref="currentFWColumn" dataField='' dataFormat={this.FWFormat} filter={{
                        type: 'CustomFilter',
                        getElement: geVersionFilter,
                        customFilterParameters: { treatmentField: 'TreatmentFWVersion', measurementField: 'MeasurementFWVersion', filterFunc: this.filterGridByFWVersion }
                    }}>Current FW</TableHeaderColumn>
                    <TableHeaderColumn dataField='' dataFormat={this.StartFormat}>Start use</TableHeaderColumn>
                    <TableHeaderColumn dataField='' dataFormat={this.EndFormat}>End use</TableHeaderColumn>
                    {/* <TableHeaderColumn dataField='' dataFormat={this.FWUpdateFormat} width='230px' filter={{
                        type: 'CustomFilter',
                        getElement: getCustomFilter,
                        customFilterParameters: { treatmentField: 'TreatmentFWUpdate', measurementField: 'MeasurementFWUpdate', filterFunc: this.filterGridByDate }
                    }}>Last FW updates</TableHeaderColumn> */}
                    <TableHeaderColumn dataField='' dataFormat={this.NeedUpdateFormat}>Need FW updates</TableHeaderColumn>
                </DataGrid>

            </div>
        )
    }
};

class ChooseVersion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            version: 0,
            handleType: enums.HANDLE_TYPE.TREATMENT,
            versionID: '',
            data: [],
            treatmentVersions: [],
            measurementVersions: [],
            selectedVersion: ''
        }

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.loadAll = this.loadAll.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.versionChange = this.versionChange.bind(this);
        this.informOnUpdate = this.informOnUpdate.bind(this);
    }

    componentDidMount() {
        this.loadAll();
    }

    handleSave() { }

    handleChange(evt) {
        var handleVal = evt.target.value;
        this.setState({
            handleType: handleVal
        });

        if (handleVal == enums.HANDLE_TYPE.TREATMENT) {
            this.setState({
                data: this.state.treatmentVersions,
                versionID: this.state.treatmentVersions[0].ID
            });
        }
        else {
            this.setState({
                data: this.state.measurementVersions,
                versionID: this.state.measurementVersions[0].ID
            });
        }

    }

    handleOpenModal() {
        this.setState({
            showModal: true
        });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    submit(evt) {
        evt.preventDefault();
    }

    loadAll() {
        //    this._loading.Show();
        axios
            .get("/data/getAllFirmareVersions/")
            .then(function (data) {
                var treatmentVersions = [];
                var measurementVersions = [];

                for (var i = 0; i < data.data.length; i++) {
                    if (data.data[i].HandleTypeID == enums.HANDLE_TYPE.MEASUREMENT) {
                        measurementVersions.push(data.data[i]);
                    }
                    else {
                        treatmentVersions.push(data.data[i]);
                    }
                }

                this.setState({
                    treatmentVersions: treatmentVersions,
                    measurementVersions: measurementVersions,
                    data: treatmentVersions,
                    versionID: treatmentVersions[0].ID
                });

                console.log(data.data);
                // this._loading.Hide();
            }.bind(this));
    }

    informOnUpdate() {
        this.props.informOnUpdate(this.state.handleType, this.state.versionID);
    }

    versionChange(evt) {
        this.setState({ versionID: evt.target.value });
    }

    render() {

        var versionOptions = [];
        for (var i = 0; i < this.state.data.length; i++) {
            versionOptions.push(<option value={this.state.data[i].ID} id="Version" name="Version" key={this.state.data[i].ID}>{this.state.data[i].Version}</option>)
        }

        return (
            <div>

                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.handleCloseModal}
                    className="Modal-Popup"
                    overlayClassName="Modal-Overlay"
                    style={{ width: '150px', height: '35px' }}>
                    <Load
                        ref={(loading) => {
                            this._loading = loading;
                        }} />
                    <h3>Choose firmware version</h3>
                    <div className="row">
                        <Col componentClass={ControlLabel} sm={3}>
                            Handle:
                            </Col>
                        <Col sm={9}>
                            <Radio name="handleType" inline value={enums.HANDLE_TYPE.TREATMENT} onChange={this.handleChange} checked={this.state.handleType == enums.HANDLE_TYPE.TREATMENT}>
                                Treatment
                                </Radio>
                            <Radio name="handleType" inline value={enums.HANDLE_TYPE.MEASUREMENT} onChange={this.handleChange}>
                                Measurement
                                </Radio>
                        </Col>
                    </div>
                    <div>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Version</ControlLabel>
                            <FormControl componentClass="select" placeholder="select" onChange={this.versionChange} value={this.state.versionID}>
                                {versionOptions}
                            </FormControl>
                        </FormGroup>
                    </div>

                    <div>
                        <button onClick={this.informOnUpdate}>INFORM SELECTED ON UPDATE</button>
                    </div>

                </ReactModal>
            </div>
        )
    }
}

class AddVersion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            version: 0,
            handleType: 'Treatment',
            file: []
        }

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.versionChange = this.versionChange.bind(this);
        this.fileChange = this.fileChange.bind(this);
    }

    handleSave() {
        let fileData = new FormData();
        var file = this.fileUpload.files[0];
        fileData.append('file', file);
        fileData.append('version', this.state.version);
        fileData.append('handleType', this.state.handleType);
        this._loading.Show();

        axios
            .post("/data/checkFwExists", {
                fileName: file.name,
                version: this.state.version,
                handleType: this.state.handleType
            })
            .then(function (data) {
                this._loading.Hide();

                var confirmResult = true;
                if (data.data == true) {
                    confirmResult = confirm("There is already a file with this version, do you want to override the file?");
                }
                if (confirmResult == true) {
                    this._loading.Show();
                    axios
                        .post("/data/saveFWUpdate", fileData, {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        })
                        .then(function (data) {
                            this._loading.Hide();

                            this.handleCloseModal();
                        }.bind(this))
                        .catch(function (error) {
                            this._loading.Hide();
                            if (error.response && error.response.data == "No permissions") {
                                window.location.replace("/login");
                            }
                            console.log(error);
                        }.bind(this));
                }
            }.bind(this))
            .catch(function (error) {
                this._loading.Hide();
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            }.bind(this));
    }

    getFileVersionFromFileName(originalFileName) {
        var version = "0";
        if(originalFileName) {
            var extention = path.extname(originalFileName);
            var fileName = path.basename(originalFileName, extention);
    
            var regex = /\d{1,}\.\d{1,}$/;
            var array = fileName.match(regex);
            if(array.length > 0) {
                version = array[0];
            }
        }
        return version;
    }

    handleOpenModal() {
        this.setState({
            showModal: true
        });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    versionChange(evt) {
        this.setState({
            version: evt.target.value
        });
    }

    fileChange(evt) {
        var version = this.getFileVersionFromFileName(evt.target.value);
        this.versionNumber.value = version;
        this.setState({
            version: version
        });
    }

    handleChange(evt) {
        this.setState({
            handleType: evt.target.value
        });
    }

    submit(evt) {
        evt.preventDefault();
    }

    render() {
        return (
            <div>
                <button className='purple btn btn-default btn btn-default' style={{ width: '150px', height: '35px', display: 'inline-block' }} onClick={() => { this.handleOpenModal() }}>+ ADD NEW VERSION</button>

                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.handleCloseModal}
                    className="Modal-Popup Modal-Popup-wide"
                    overlayClassName="Modal-Overlay"
                    style={{ width: '150px', height: '35px' }}>
                    <Load
                        ref={(loading) => {
                            this._loading = loading;
                        }} />
                    <h3>Add Firmware Update</h3>
                    <Form horizontal onSubmit={this.submit} >
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={3}>
                                Version:
                            </Col>
                            <Col sm={9}>
                                <FormControl readOnly type="text" id="Version" name="Version" inputRef={(ref) => this.versionNumber = ref} onChange={this.versionChange} />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={3}>
                                File:
                            </Col>
                            <Col sm={9}>
                                <input name="myFile" type="file" ref={(ref) => this.fileUpload = ref} accept=".out" 
                                onChange={(event)=> { 
                                    this.fileChange(event) 
                                }}
                                onClick={(event)=> {
                                    this.fileChange(event)  
                                      event.target.value = null
                                    }
                                }
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={3}>
                                Handle:
                            </Col>
                            <Col sm={9}>
                                <Radio name="handleType" inline value="Treatment" onChange={this.handleChange} checked={this.state.handleType == "Treatment"}>
                                    Treatment
                                </Radio>
                                <Radio name="handleType" inline value="Measurement" onChange={this.handleChange}>
                                    Measurement
                                </Radio>
                            </Col>
                        </FormGroup>
                        <button className="btnSave" onClick={this.handleSave}>Save</button> <button className="btnCancel" onClick={this.handleCloseModal}>Cancel</button>
                    </Form>
                </ReactModal>
            </div>
        )
    }
}

class VersionFilter extends React.Component {
    constructor(props) {
        super(props);
        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
        this.DateChange = this.DateChange.bind(this);

        this.state = {
            date: new Date()
        }

    }

    cleanFiltered() {
        this.refs.textField.value = "";
        this.props.filterFunc(this.props.treatmentField, this.props.measurementField, "");
    }

    filter(event) {
        this.props.filterFunc(this.props.treatmentField, this.props.measurementField, event.target.value);
    }

    isFiltered(targetValue) {
        if (targetValue != '') {
            return (true);
        } else {
            return (false);
        }
    }

    DateChange(date) {
        this.setState({ date: date });
    }

    render() {
        var date = this.state.date;
        //   this.fromLabel = new Date(y, m, 1);
        return (
            <div>
                <input ref="textField" type="text" onChange={this.filter} />
            </div>
        );
    }
}

class DateFilter extends React.Component {
    constructor(props) {
        super(props);
        this.filter = this.filter.bind(this);
    }

    filter(newDate) {
        this.props.filterFunc(this.props.treatmentField, this.props.measurementField, newDate);
    }

    render() {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        this.fromLabel = new Date(y, m, 1);
        return (
            <div>
                <Datepicker
                    ContainerType='None'
                    Label="From Date"
                    onChange={this.filter}
                    Value={this.fromLabel} startDate={new Date()} />

            </div>
        );
    }
}

function getCustomFilter(filterHandler, customFilterParameters) {

    return (
        <DateFilter filterHandler={filterHandler} filterFunc={customFilterParameters.filterFunc} treatmentField={customFilterParameters.treatmentField}
            measurementField={customFilterParameters.measurementField} />
    );
}


function geVersionFilter(filterHandler, customFilterParameters) {

    return (
        <VersionFilter filterHandler={filterHandler} filterFunc={customFilterParameters.filterFunc} treatmentField={customFilterParameters.treatmentField}
            measurementField={customFilterParameters.measurementField} />
    );
}


// WEBPACK FOOTER //
// ./modules/deviceInfo.jsx